const pt = {
  placeholderText: "Digite",
  closeContentText: "Encerrar conversa atual?",
  cancelText: "Cancelar",
  okText: "OK",
  loadingAnswerQuestions:
    "Respondendo à pergunta anterior. Aguarde antes de enviar.",
  networkAnomalyText: "Falha na rede. Tente novamente mais tarde.",
  errorText: "Erro de servidor",
  messageTooShort: "É necessário inserir pelo menos dois caracteres.",
  messageTooLong: "Não pode exceder 200 caracteres.",
  systemErrorText:
    "​​Erro de sistema. Por favor, tente novamente mais tarde.​​​​​",
  fileSizeExceeded: "Um arquivo não pode exceder {maxSize}MB.",
  abnormalDisconnectionText: "Conexão interrompida. Reconectando...",
  evaluationText: "A sua avaliação nos ajuda a melhorar!",
  emailLabel: "Endereço de Email​",
  emailPlaceholder: "Digite seu endereço de e-mail",
  emailErrorText: "Formato de e-mail inválido.",
  productLabel: "Produto",
  productPlaceholder: "Selecione um produto",
  problemLabel: "Descrição do problema",
  problemPlaceholder: "Descreva seu problema em detalhes",
  submitText: "Enviar",
  submitField: "Falha no envio. Por favor, tente novamente mais tarde.",
  thankText:
    "Obrigado pela sua colaboração! Entraremos em contato o mais rápido possível! Por favor, verifique seu e-mail ou {link}​ para acompanhar as respostas!",
  clickHere: "clique aqui​​",
  thankEvaluation: "​​Obrigado pela sua avaliação!",
  codeLabel: "Código de verificação",
  codePlaceholder: "Por favor, insira o código de verificação",
  submittedSuccessfully: "Enviado com sucesso",
  supportContact: "Contato de Suporte",
  stillCancel: "Cancelar mesmo assim",
  useDiscount: "Usar desconto",
  pauseDuration: "Duração da pausa",
  uploadAttachment: "Anexar arquivo",
};
export default pt;
